import React, { useState } from "react";

import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Modal from "@material-ui/core/Modal";

import BasicCard from "../BasicCard";
import Dropdown from "../Dropdown";

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary
  },
  modal: {
    position: "absolute",
    width: 400,
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)"
  }
}));

function ChooseColor({
  defaultColor,
  focus,
  label,
  onSelect,
  options,
  materialId,
  productId,
  selectedColor,
  setSelectedColor,
  systemId
}) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Dropdown
        focus={focus}
        options={options}
        label={label}
        onChange={newValue => {
          setSelectedColor(newValue);
          if (onSelect) onSelect();
        }}
        translationKey="names.colors"
        value={selectedColor}
      />
    </div>
  );
}

export default ChooseColor;
